// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Global AI-credit peg response — returned by GET/POST /ai/credits/peg.
 *
 * ai_credit_peg_usd is the GLOBAL USD-of-provider-cost per credit
 * (D-a/D-b, docs/ai-credits-console-refactor-plan.md §2.1-2.5):
 *
 *     credits = provider_cost_usd / ai_credit_peg_usd
 *
 * GLOBAL only — never per-model, never per-franchise (a per-model or
 * per-franchise peg would be a subsidy disguised as a unit of measure).
 *
 * Always a positive decimal string, never null: when the config_sistema row
 * is absent the controller falls back to the seeded default (0.00040000) so
 * the credit computation is never left without a peg.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PegResponseDados {
ai_credit_peg_usd: string
}

export type AiCredits_PegResponse = ApiResponse<AiCredits_PegResponseDados>;

registerResponseContract('AiCredits_PegResponse', {
  ai_credit_peg_usd: { type: 'string',  required: true },
})
